import { Pipe, PipeTransform } from '@angular/core';
import { get } from '../utils/util.functions';

@Pipe({
  name: 'get',
  standalone: true,
})
export class ObjectValueGetterPipe implements PipeTransform {
  transform(obj: object, key: string) {
    return get(obj, key as never);
  }
}
